import { useState } from "react";
import { downloadCsv } from "@/lib/manufacturing/inventoryCsvExport";
import {
  materialUsesToCsv,
  type MaterialUseExportDetail,
} from "@/lib/manufacturing/materialUsesCsvExport";
import { getManufacturingMaterialUseDetail } from "@/lib/manufacturing/materialUsesClient";

function stamp(): string {
  return new Date().toISOString().slice(0, 10);
}

export function useManufacturingMaterialUsesExport() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function exportCsv(useIds: readonly string[]) {
    if (useIds.length === 0) return;
    setBusy(true);
    setError(null);
    const details: MaterialUseExportDetail[] = [];
    for (const id of useIds) {
      const result = await getManufacturingMaterialUseDetail(id);
      if (!result.ok) {
        setError(result.error || `Failed to load part use ${id}`);
        setBusy(false);
        return;
      }
      details.push({
        use: result.data.use,
        members: result.data.members,
      });
    }
    downloadCsv(`mfg-part-uses-${stamp()}.csv`, materialUsesToCsv(details));
    setBusy(false);
  }

  return { busy, error, exportCsv, clearError: () => setError(null) };
}
